import React, { useEffect, useState } from "react";
import useI18n from "../hooks/useI18n.js";
import { Text } from "@100mslive/roomkit-react";
import { ErrorDialog } from "../../primitives/DialogContent";

export const InitErrorModal = ({ notification }) => {
  const [showModal, setShowModal] = useState(false);
  const { t } = useI18n("common");
  const [info, setInfo] = useState({ title: t("init_error"), description: "" });

  useEffect(() => {
    const data = notification?.data;
    if (!data || data.action !== "INIT") {
      return;
    }
    let description;
    let title;
    if (data.description.includes("role is invalid")) {
      description = t("role_does_not_exist");
      title = t("invalid_role");
    } else if (data.description.includes("room not active")) {
      title = t("room_is_disabled");
      description = t("room_disabled_cannot_join");
    } else {
      description = data.description;
      title = t("init_error");
    }
    setInfo({ title, description });
    setShowModal(true);
  }, [notification, t]);

  return (
    <ErrorDialog
      open={showModal}
      onOpenChange={setShowModal}
      title={info.title}
    >
      <Text variant="sm" css={{ wordBreak: "break-word" }}>
        {info.description} <br />
      </Text>
    </ErrorDialog>
  );
};
